module.exports = __webpack_public_path__ + "static/img/72 (2).9de51a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/72 (2).jpg
// module id = U2Bo
// module chunks = 0